import { useState } from 'react'
import * as React from 'react'
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect'
import { getElementTextDirection, type TextDirection } from 'lib/dom/logicalScroll'

export default function useTextDirection(
  ref: React.RefObject<HTMLElement | null>,
): TextDirection {
  const [textDirection, setTextDirection] = useState<TextDirection>('ltr')

  useIsomorphicLayoutEffect(() => {
    if (ref.current) {
      setTextDirection(getElementTextDirection(ref.current))
    }
  }, [ref])

  return textDirection
}
